import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a7542fa2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "sell-point-and-materials"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量添加 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 品牌卖点导入 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 视频资料导入 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 全部导出 ");

const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["href"];

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 请下载Excel模版，严格按照模板上的提示信息填写，且不要修改Excel模板格式，保存后上传到系统，一次可最多导入500条。 ", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "1、标品编码必填（商品编码）；", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2、品牌名、别名、商品卖点、产品优势不能全为空；", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 3、品牌名只允许输入中英文或数字且不能超过30个字；别名只允许输入中英文或数字且不能超过30个字；卖点不能超过100个字；产品优势不能超过100字； ", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "以上格式错误的数据均会提示导入失败", -1));

import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { dateFormat, getVexTableProps } from '@/config';
import { getSellPointAndMaterialsList, delMerInfo, exportForAsync } from '@/request';
import { ElMessageBox, ElMessage } from 'element-plus';
import { importSellPointFile, importMaterialsFile, importMerIntroductionExcel, importTrainMaterialExcel, exportMerIntroductionExcel } from '@/request/api';
import UploadModal from '@/components/UploadModal.vue';
export default {
  name: 'SellPointAndMaterials',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const form = ref({
      merKeyword: '',
      manufacture: '',
      endTime: '',
      startTime: ''
    });

    function initForm(source = {
      merKeyword: '',
      manufacture: '',
      endTime: '',
      startTime: ''
    }) {
      form.value = _objectSpread(_objectSpread({}, form.value), source);
    }

    const table = ref();
    const uploadOption = ref({
      action: importSellPointFile.url,
      name: 'merIntroductionFile',
      templateLink: importMerIntroductionExcel
    });
    const showUploadModel = ref(false);
    let total = 0;
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: '250px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '250px'
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '厂家',
        field: 'manufacture',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '别名',
        field: 'prodAlias',
        width: '150px',
        showOverflow: true
      }, {
        title: '品牌名',
        field: 'brandName',
        width: '150px',
        showOverflow: true
      }, {
        title: '商品卖点',
        field: 'merIntroduction',
        width: '150px',
        showOverflow: true
      }, {
        title: '产品优势',
        field: 'salesTalk',
        width: '250px',
        showOverflow: true
      }, {
        title: '视频资料',
        field: 'videoNum',
        width: '100px',
        slots: {
          default: 'videoNum'
        }
      }, // {
      //   title: '培训链接',
      //   field: 'trainLink',
      //   width: '250px',
      //   slots: { default: 'link' },
      //   showOverflow: true
      // },
      {
        title: '更新时间',
        width: '150px',
        field: 'updateAt'
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '100px',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSellPointAndMaterialsList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              total = data.total;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function search() {
      table.value.commitProxy('reload');
    }

    function reset() {
      initForm();
      table.value.commitProxy('reload');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据`, {
        title: '删除'
      }).then(() => {
        delMerInfo({
          __repeat: true,
          __warn: true
        }, {
          params: {
            supMerIntroductionIdS: selectRows.map(row => row.supMerIntroductionId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage({
              showClose: true,
              message: '操作成功!',
              type: 'success'
            });
            table.value.commitProxy('query');
          }
        });
      });
    }

    function uploadFile(type = 'sellPoint') {
      // materials
      if (type === 'sellPoint') {
        uploadOption.value = {
          action: importSellPointFile.url,
          name: 'merIntroductionFile',
          templateLink: importMerIntroductionExcel.url,
          title: '品牌卖点导入'
        };
      } else {
        uploadOption.value = {
          action: importMaterialsFile.url,
          name: 'trainLinkFile',
          templateLink: importTrainMaterialExcel.url,
          title: '培训资料导入'
        };
      }

      showUploadModel.value = true;
    }

    function downloadAll() {
      exportForAsync(_objectSpread(_objectSpread({
        __repeat: true,
        __warn: true
      }, form.value), {}, {
        methodName: exportMerIntroductionExcel.url,
        modularflag: 'merIntroduction',
        fileName: '商品卖点信息列表',
        count: total
      }));
    }

    function edit(row) {
      router.push({
        name: 'BatchAddSellPointAndMaterials',
        query: {
          from: route.name,
          prodNo: row.prodNo
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.merKeyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.merKeyword = $event),
                placeholder: "输入商品名/编号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "厂家"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.manufacture,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.manufacture = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "更新开始时间",
              "label-width": "110px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "更新结束时间",
              "label-width": "110px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: search
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "CirclePlus",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push({
            name: 'BatchAddSellPointAndMaterials',
            query: {
              from: _ctx.$route.name
            }
          }))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "UploadFilled",
          onClick: _cache[5] || (_cache[5] = $event => uploadFile('sellPoint'))
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "UploadFilled",
          onClick: _cache[6] || (_cache[6] = $event => uploadFile('materials'))
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Download",
          onClick: downloadAll
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        videoNum: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          class: "link",
          onClick: $event => edit(row)
        }, _toDisplayString(row.videoNum), 9, _hoisted_9)]),
        link: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          class: "link",
          href: row.trainLink,
          target: "_blank"
        }, _toDisplayString(row.trainLink), 9, _hoisted_10)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(UploadModal, {
        option: uploadOption.value,
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showUploadModel.value = $event)
      }, {
        help: _withCtx(() => [_hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16]),
        _: 1
      }, 8, ["option", "modelValue"])]);
    };
  }

};